module.exports = __webpack_public_path__ + "static/assets/5dc1984f2746fe86d8c1232120c363ae.png";